'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsFactory = undefined;

var _ecommerceManagerFactoryGA = require('./ecommerceManagerFactoryGA4');

var _constants = require('./constants');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EVENT_ATTR_PREFIX = 'eventAttribute_';

var productToItem = function productToItem(product) {
  return {
    item_id: product.id,
    item_category: product.brand,
    item_category2: product.name,
    item_category3: product.plan,
    item_list_id: product.list,
    index: product.position,
    item_variant: product.variant,
    item_brand: 'Spotahome',
    price: product.price,
    quantity: product.quantity || 1
  };
};

var parseProductInEcommerce = function parseProductInEcommerce() {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    return products.length ? products.map(productToItem) : 'sale_event_not_set';
  } catch (e) {
    console.log(e);
    return 'sale_event_error';
  }
};

var analyticsFactory = function analyticsFactory(_ref) {
  var send = _ref.send,
      setCustomDimension = _ref.setCustomDimension,
      flush = _ref.flush;

  var sendGA4Event = function sendGA4Event(eventName, eventAttributes) {
    var formattedEventAttributes = eventAttributes ? Object.keys(eventAttributes).reduce(function (a, c) {
      return Object.assign({}, a, _defineProperty({}, EVENT_ATTR_PREFIX + '_' + c, eventAttributes[c]));
    }, {}) : {};

    send(Object.assign({
      event: _constants.EVENT_GA4,
      eventName: eventName
    }, formattedEventAttributes), {
      sendInHouseAnalytics: eventAttributes.sendInHouseAnalytics
    });
  };

  var sendGA4EcommerceEvent = function sendGA4EcommerceEvent(_ref2) {
    var ecommerceAction = _ref2.ecommerceAction,
        ecommerce = _ref2.ecommerce,
        sendInHouseAnalytics = _ref2.sendInHouseAnalytics;

    var products = ecommerce.products,
        restEcommerce = _objectWithoutProperties(ecommerce, ['products']);

    send({
      ecommerceProducts: null
    });
    send({
      event: _constants.EVENT_GA4_ECOMMERCE,
      eventName: ecommerceAction,
      ecommerceProducts: parseProductInEcommerce(products),
      ecommerce: restEcommerce
    }, { sendInHouseAnalytics: sendInHouseAnalytics });
  };

  var set = function set(payload) {
    send(payload);
  };

  return {
    set: set,
    setCustomDimension: setCustomDimension,
    ecommerceManager: (0, _ecommerceManagerFactoryGA.ecommerceManagerFactory)(sendGA4EcommerceEvent),
    sendGA4Event: sendGA4Event,
    flush: flush
  };
};

exports.analyticsFactory = analyticsFactory;
exports.default = { analyticsFactory: analyticsFactory };
//# sourceMappingURL=index.js.map